import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators'

import {BaseService} from 'app/views/base.service';
import { Site } from '../models/support.model';
import { DataProvider2, DataProviderFactory, DataRequest } from "app/provider/data2.provider";

interface IBillingransaction {
	transactionId: string;
	tariffId: string;
	tariffVariant: string;
	recurrentProfile: string;
}

@Injectable()
export class SitesService extends BaseService {
	public widget: DataRequest;
	public publishedSite: DataRequest;
	public siteAction: DataRequest;
	public loadStat: DataRequest;
	public mx: DataRequest;
	public siteTop: DataRequest;
	public widgetSearch: DataRequest;
	public categoryDynamics: DataRequest;
	public siteCategories: DataRequest;
	
	constructor(
		public http: HttpClient,
		public dp2: DataProvider2,
		public dpf: DataProviderFactory,
	) {
		super(http);
		
		this.widget = this.dpf.getNew('widget');
		this.publishedSite = this.dpf.getNew('published_site');
		this.siteAction = this.dpf.getNew('site/action');
		this.loadStat = this.dpf.getNew('load_stat');
		this.mx = this.dpf.getNew('mx');
		this.siteTop = this.dpf.getNew('site_top');
		this.widgetSearch = this.dpf.getNew('widget_search');
		this.categoryDynamics = this.dpf.getNew('category_dynamics');
		this.siteCategories = this.dpf.getNew('site_categories');
	}
	
	
	getTransactionByQuery(query): Observable<IBillingransaction[]> {
		return this.dp2.get('/transaction', query).pipe(
			map(transactions => <IBillingransaction[]>transactions)
		);
	}
	
	
	returnPaid(siteId, data) {
		return this.dp2.post(
			`/support/negotiator/sites/${siteId}/returnPaid`,
			data
		);
	}
}
